import { getBarCodeData } from "../template/scanData"

import { customGetBarCodeData } from "../customization/scanData"

export const barCodeConfigs = () => {

  let getData = getBarCodeData

  // console.log('customGetBarCodeData', typeof customGetBarCodeData)

  // if customization - must be function
  if (typeof customGetBarCodeData === "function") getData = customGetBarCodeData

  return {
    getData
  }

}